<hs-account-list-grid
  (onAccountsSelected)="setSelectedAccounts($event)"
  (onCommentaryAccountSelected)="setCommentaryAccount($event)"
  (onTotalBreaksSelected)="setSelectedTotalBreaks($event)"
  (onLoadAccount)="setLoadedAccount($event)"
  (loadAccountWithTimePeriod)="loadAccountWithTimePeriod($event)"
  (onAccountsInViewChange)="accountsInViewChanged($event)"
  (activateExternalData)="focusExternalFilePanel($event)"
  [session]="session | async"
  [currentUser]="currentUser | async"
  [rowUpdated]="updatedAccount | async"
  [actualReconDate]="actualReconDate | async"
  [approvalsAccountList]="approvalsAccountList"
>
</hs-account-list-grid>
